import React from 'react';
import { Switch } from '@cambridgeassessment/cambridge-ui';
import { EntryCardInner, StyledComponentContainer } from './ToggleRow.styles';
import { Resubmission } from '@cambridgeassessment/lib-ee-commons/src/domain/resubmission';
import { ToggleRowTooltip } from './ToggleRowTooltip';

interface Props {
  title: string;
  resubmission?: Resubmission;
  onChange: (checked: boolean) => void;
  qaId: string;
  tooltip?: string;
  disabled?: boolean;
}

export const ToggleRow: React.FC<Props> = ({ title, resubmission, onChange, qaId, disabled, tooltip }) => {
  const isEnabled = !!resubmission?.enabled;

  return (
    <EntryCardInner data-qa-id={qaId}>
      <StyledComponentContainer data-qa-id={`${qaId}-title`}>{title}</StyledComponentContainer>
      <ToggleRowTooltip tooltip={tooltip}>
        <Switch dataQaId={`${qaId}-switch`} checked={isEnabled} onChange={onChange} disabled={disabled} />
      </ToggleRowTooltip>
    </EntryCardInner>
  );
};

export default ToggleRow;
